import PageGallery from '../../../common/ts/components/PageGallery';
import LazyLoadingComponent from "../../../common/ts/components/LazyLoadingComponent";
import GA4Tracking from "../../../common/ts/core/tracking/GA4Tracking";
import snippet from "../components/snippet/snippet";
import handleShowSimilarAdsPopup from "./handleShowSimilarAdsPopup";
import {EventBus} from "../../../common/ts/events/EventBus";
import {SerpClickSimilarAdsRequestedEvent, SerpClickSimilarAdsRequestedPayload} from "./events";

let eventBus: EventBus;

class Listings {
  private lazyLoading = new LazyLoadingComponent();

  constructor() {
  }

  public init(ev = EventBus.getInstance()) {
    eventBus = ev;
    this.trackGA4SerpEvents();
    const listingsSection = document.querySelector('#listings') as HTMLElement;
    snippet.init({
      similarClickAdsData: {
        search: listingsSection.dataset.searchquery!,
        pageViewId: listingsSection.dataset.pvid!,
        pageSectionId: listingsSection.dataset.tracking!,
        retrievalEvent: (params) =>
            eventBus.emit(
                new SerpClickSimilarAdsRequestedEvent(params as SerpClickSimilarAdsRequestedPayload)
            ),
      },
    });
    this.setupEventListeners();
    this.lazyLoading.setupLazyLoading();
    this.saveLastLoadSerpUrl();
  };

  private trackGA4SerpEvents = () => {
    GA4Tracking.trackEvent("serp-pageview");
    if (this.isRetentionEmail()) {
      GA4Tracking.trackEvent("serp-email-signin");
    }
  };

  private isRetentionEmail: () => boolean = () => {
    return document.querySelector("[data-isRetentionEmail]") != null;
  };

  public setupEventListeners = () => {
    const bannerListings = Array.from(document.querySelectorAll('[data-listingbanner]'));
    bannerListings.forEach((item) => {
      const id = (item as HTMLElement).dataset.idanuncio!.toString()
      this.registerBannerListingEvents(id, item as HTMLElement)
    })
  };
  private registerBannerListingEvents = (id: string, bannerListing: HTMLElement) => {
    bannerListing.addEventListener('click', () => {
      handleShowSimilarAdsPopup(id);
    });
  };

  private saveLastLoadSerpUrl() {
    const url = decodeURIComponent(window.location.href);
    localStorage.setItem("lastSerpUrl", url);
  }
}
// eslint-disable-next-line no-new
new PageGallery();
new Listings().init();
